import { useState, useRef, useEffect } from 'react';

type Props = {
  logicCount: number;
  onShowLogic: () => void;
  onShowAdvanced: () => void;
  onInsertBelow: () => void;
  onRemove: () => void;
  /** 0901 新增：下方插入分页栏 */
  onInsertPagebreakBelow?: () => void;
  /** 0901 新增：下方插入标题说明 */
  onInsertStatementBelow?: () => void;
};

export default function QuestionMenu({
  logicCount,
  onShowLogic,
  onShowAdvanced,
  onInsertBelow,
  onRemove,
  onInsertPagebreakBelow,
  onInsertStatementBelow,
}: Props) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const close = () => setOpen(false);

  return (
    <div className="q-menu" ref={rootRef}>
      <button
        type="button"
        className="q-menu-trigger"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
        title="题目操作"
      >
        ⋮
      </button>
      {open && (
        <div className="q-menu-popup" role="menu">
          <button className="q-menu-item" onClick={() => { close(); onShowLogic(); }} disabled title="本期占位">
            <span>选项样式</span>
            <i>›</i>
          </button>
          <button className="q-menu-item" onClick={() => { close(); onShowLogic(); }} disabled title="本期占位">
            <span>选项填空</span>
            <i>›</i>
          </button>
          <button className="q-menu-item" onClick={() => { close(); onShowLogic(); }}>
            <span>题目显示逻辑</span>
            {logicCount > 0 && <span className="q-menu-count">{logicCount}</span>}
          </button>
          <button className="q-menu-item" onClick={() => { close(); onInsertBelow(); }}>
            <span>下方插入新题</span>
          </button>
          {onInsertStatementBelow && (
            <button className="q-menu-item" onClick={() => { close(); onInsertStatementBelow(); }} title="在下方插入一个标题说明（不可作答）">
              <span>下方插入标题说明</span>
            </button>
          )}
          {onInsertPagebreakBelow && (
            <button className="q-menu-item" onClick={() => { close(); onInsertPagebreakBelow(); }} title="在下方插入分页栏，填写端将按页切换">
              <span>下方插入分页栏</span>
            </button>
          )}
          <div className="q-menu-divider" />
          <button className="q-menu-item" onClick={() => { close(); onShowAdvanced(); }}>
            <span>高级设置</span>
          </button>
          <div className="q-menu-divider" />
          <button className="q-menu-item q-menu-item-danger" onClick={() => { close(); onRemove(); }}>
            <span>删除</span>
          </button>
        </div>
      )}
    </div>
  );
}